var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaflet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8723 0.25V2.75C22.8723 14.7837 16.1561 20.25 7.87234 20.25H5.49484C5.75984 16.485 6.93234 14.2062 9.99234 11.4987C11.4973 10.1675 11.3698 9.39875 10.6286 9.84C5.52359 12.8775 2.98734 16.9825 2.87484 23.5375L2.87109 24H0.371094C0.371094 22.2962 0.516094 20.75 0.803594 19.335C0.516094 17.7175 0.371094 15.5225 0.371094 12.75C0.371094 5.84625 5.96734 0.25 12.8711 0.25C15.3711 0.25 17.8723 1.5 22.8723 0.25Z",
    fill: "url(#paint0_linear_344_323)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_344_323",
    x1: 11.6217,
    y1: 0.25,
    x2: 11.6217,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61DC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008D39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaflet);
export default __webpack_public_path__ + "static/media/leaflet.1585cea8132502e6e011968cc2efb5ef.svg";
export { ForwardRef as ReactComponent };